import type { MediaFileId } from '@connected/api-client/database/schema';

export function generateMediaFileId(electricalProjectVersionId: string, electricalProjectFileId: string, fileId?: string): MediaFileId {
    const mediaFileId = `${electricalProjectVersionId}.${electricalProjectFileId}`;
    if (fileId)
        return `${mediaFileId}.${fileId}` as MediaFileId;
    return mediaFileId as MediaFileId;
}
